// @flow strict
import * as React from 'react';
import * as DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser';

type Props = {
  unsanitizedHtml: string,
}

const SanitizedHtml = (props: Props): React.Node => {
  const sanitizedHtml = DomPurify.sanitize(props.unsanitizedHtml)
  return ReactHtmlParser(sanitizedHtml)
};

export default SanitizedHtml;
